<!-- chat.component.html -->
<div
  class="tw-flex tw-flex-col tw-h-full fit-height-on-page tw-min-h-[400px] tw-border tw-border-slate-200 tw-rounded-lg tw-bg-white tw-overflow-y-auto">
  <!-- Header -->
  <div class="tw-flex tw-items-center tw-justify-between tw-px-4 tw-py-2 tw-border-0 tw-border-b tw-border-slate-200 tw-border-solid">
    <div class="tw-text-xl tw-font-semibold tw-text-sbGray-800">
      KI chat
    </div>
    <div class="tw-flex tw-gap-2">
      <button
        sb-button-primary
        type="button"
        [color]="'red'"
        [iconButton]="true"
        [sbTooltip]="'lang.globals.clearHistory' | translate"
        (click)="kiService.clearHistory()"
        [icon]="'trash'"
      >
      </button>
      <sb-icon
        icon="chevronLeft"
        class="tw-cursor-pointer tw-text-sbBlue-500"
        (click)="kiService.closeKIPanel()"
      >
      </sb-icon>
    </div>
  </div>

  <!-- History -->
  <div class="tw-overflow-y-auto">
    <sb-comp-ki-history></sb-comp-ki-history>

    <!-- Response loading -->
    @if (kiService.loadingResponse()) {
      <div class="tw-w-full tw-flex tw-justify-center tw-items-center tw-h-10">
        <div class="tw-flex tw-gap-2 tw-justify-center tw-items-center tw-h-full">
          <sb-icon icon="loadingDotsAnimation" [animationOptions]="{loop: true, autoplay: true}"></sb-icon>
          <div>{{ 'lang.globals.kiLoadingResponse' | translate }}</div>
        </div>
      </div>
    } @else {
      @let loadingHistory = kiService.loadingHistory();
      <!-- Input -->
      <form
        class="tw-border-t tw-border-slate-200 tw-p-2 tw-flex tw-gap-2 tw-items-center"
        (ngSubmit)="send()"
      >
        <input
          [(ngModel)]="newMessage"
          name="message"
          type="text"
          [disabled]="loadingHistory"
          [placeholder]="'lang.globals.writeMessage' |translate"
          class="tw-input tw-w-full"
        />
        <button
          sb-button-primary
          color="blue"
          type="submit"
          icon="send"
          [iconButton]="true"
          class=""
          [disabled]="!newMessage.trim() || loadingHistory"
        >
          <!-- {{ 'lang.globals.send' |translate }} -->
        </button>
      </form>

    }
  </div>
</div>
